import React from 'react';
import { connect } from 'react-redux';
import { callService } from '../tools';
import ContratoDatosForm from '../gnp-registro-seguridad/contrato-datos.cmpt.js';

const mapState = (state) => {
    return {
        loading: state.global.loading,
        hashOne: state.registro.hashOne,
        hashTwo: state.registro.hashTwo,
        password: state.registro.password,
        pregunta1: state.registro.pregunta1,
        pregunta2: state.registro.pregunta2,
        respuesta1: state.registro.respuesta1,
        respuesta2: state.registro.respuesta2,
        mediosElectronicos: state.contrato.mediosElectronicos
    };
};

const mapDispatch = (dispatch, ownProps) => {
    return {
        loader: (show) => {
            dispatch({ "type": "LOADER", "show": show });
        },
        alerta: (sMensaje) => {
            dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje": sMensaje });
        },
        alertaCode: (sCode) => {
            dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
        },
        alertaClose: (sMensaje, fnClose) => {
            dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "ERROR", "mensaje": sMensaje, "accion": fnClose });
        },
        siguientePaso: () => {
            dispatch({ "type": "CONTRATOS_PASO", "paso": 5 });
        },
        setPaso: (paso) => {
            dispatch({ "type": "CONTRATOS_PASO", "paso": paso });
        }
    }
}

class Confidencialidad extends React.Component {

    submit = () => {
        let $this = this;
        $this.props.loader(true);

        new callService({
            service: 'registro.datosContratos',
            secure: true,
            data: {
                hashOne: this.props.hashOne,
                hashTwo: this.props.hashTwo,
                password: this.props.password,
                pregunta1: this.props.pregunta1,
                pregunta2: this.props.pregunta2,
                respuesta1: this.props.respuesta1,
                respuesta2: this.props.respuesta2,
                mediosElectronicos: this.props.mediosElectronicos
            }
        }).execute().then((respuesta) => {
            console.log("Respuesta", respuesta);
            $this.props.loader(false);

            if (respuesta.aceptacionContratos.banExito) {
                $this.props.siguientePaso();
            }
        }).catch((error) => {
            console.log("Error", error);
            $this.props.loader(false);
            if (error.message.codigoError) {
                if (error.message.codigoError == "eCl00026") { //La contraseña nueva no puede ser la misma que una contraseña utilizada previamente.
                    $this.props.alertaClose(error.message.mensajeTecnico, () => {
                        $this.props.setPaso(1);
                    });
                } else {
                    $this.props.alertaCode(error.message.codigoError);
                }
            } else {
                $this.props.alerta(error.message.mensaje);
            }
        });
    }

    render() {
        return <ContratoDatosForm onSubmit={this.submit} />
    }
}

export default connect(mapState, mapDispatch)(Confidencialidad);


// WEBPACK FOOTER //
// ./src/registro-seguridad/contrato-datos.cmpt.js